import DoAPICall from './DoAPICall'

//Consumer Type
    export async function consumerTypeAll(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/consumertypes/all?dateFrom='+params.from+'&dateTo='+params.to+'&consumerType='+params.consumerType,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function consumerTypeSummary(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/consumertypes/summary?dateFrom='+params.from+'&dateTo='+params.to,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Consumer Tier
    export async function consumerTierAll(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/consumertiers/all?dateFrom='+params.from+'&dateTo='+params.to+'&consumerTier='+params.consumerTier,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function consumerTierSummary(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/consumertiers/summary?dateFrom='+params.from+'&dateTo='+params.to,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

// Revenue Point
    export async function revenuePointAll(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/revenuepoints/all?dateFrom='+params.from+'&dateTo='+params.to+
                    '&revenuePoint='+params.revenuePoint+'&client_id='+params.client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function revenuePointSummary(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/revenuepoints/summary?dateFrom='+params.from+'&dateTo='+params.to+
                    '&client_id='+params.client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

// Revenue Collector
    export async function revenueCollectorAll(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/collectors/all?dateFrom='+params.from+'&dateTo='+params.to+
                                    '&revenueCollector='+params.revenueCollector,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function revenueCollectorSummary(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/collectors/summary?dateFrom='+params.from+'&dateTo='+params.to,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }


    // Revenue By Providers
    export async function paymentsProviderAll(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/providers/all?dateFrom='+params.from+'&dateTo='+params.to+
                        '&id='+params.id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function paymentsProviderSummary(userToken, params){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'payments/providers/summary?dateFrom='+params.from+'&dateTo='+params.to,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }


        // Revenue By Status
        export async function revenueStatusAll(userToken, params){
            const apiPayload = {
                httpMethod:'get',
                userToken,
                uri:'payments/status/all?dateFrom='+params.from+'&dateTo='+params.to+
                                    '&paymentStatus='+params.paymentStatus,
                payLoad:{},
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }
    
        export async function revenueStatusSummary(userToken, params){
            const apiPayload = {
                httpMethod:'get',
                userToken,
                uri:'payments/status/summary?dateFrom='+params.from+'&dateTo='+params.to,
                payLoad:{},
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

        // Revenue By Menu Type
        export async function revenueTypeAll(userToken, params){
            const apiPayload = {
                httpMethod:'get',
                userToken,
                uri:'payments/types/all?dateFrom='+params.from+'&dateTo='+params.to+
                                    '&menu_id='+params.menu_id,
                payLoad:{},
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }
    
        export async function revenueTypeSummary(userToken, params){
            const apiPayload = {
                httpMethod:'get',
                userToken,
                uri:'payments/types/summary?dateFrom='+params.from+'&dateTo='+params.to,
                payLoad:{},
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }
